import { RawConditionOperator } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

export const CONTEXT_VARIABLES = [
  { label: "Apuesta",                       value: "${apuesta}" },
  { label: "Categoría Grid",                value: "${categorica_grid}" },
  { label: "Desistimiento últimos 15 días", value: "${desistimiento_ultimos_15_dias}" },
  { label: "País",                          value: "${country}" },
  { label: "Días en inventario",            value: "${dias}" },
  { label: "Días Full",                     value: "${dias_full}" },
  { label: "Categoría Bono 2",              value: "${categorica_bono_2}" },
  { label: "Tipo de publicación",           value: "${tipo_publicacion}" },
  { label: "Valor de compra (V-Price)",     value: "${v_price}" },
];

export const CONDITION_OPERATORS: { value: RawConditionOperator; label: string }[] = [
  { value: "equals",           label: "= igual a" },
  { value: "not_equals",       label: "≠ distinto de" },
  { value: "greater_than",     label: "> mayor que" },
  { value: "greater_or_equal", label: "≥ mayor o igual a" },
  { value: "less_than",        label: "< menor que" },
  { value: "less_or_equal",    label: "≤ menor o igual a" },
];
